import { render, staticRenderFns } from "./SmsComponent.vue?vue&type=template&id=8a64ec38&"
import script from "./SmsComponent.vue?vue&type=script&lang=js&"
export * from "./SmsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports